// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"3b11e542","473":"35335960"}[chunkId] + ".chunk.js";
};